(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-guide"]) return;
  try {
    
  document.querySelectorAll('[data-article-guide]').forEach(function (root) {
    var body = root.querySelector('[data-article-body]');
    var tocWrap = root.querySelector('[data-toc-wrap]');
    var toc = root.querySelector('[data-toc]');
    var toggle = root.querySelector('[data-toc-toggle]');
    if (!body || !toc) { return; }

    var heads = body.querySelectorAll('h2');
    if (!heads.length) {
      if (tocWrap) { tocWrap.style.display = 'none'; }
      return;
    }

    var mq = window.matchMedia('(max-width: 1000px)');

    function collapse(state) {
      tocWrap.classList.toggle('is-collapsed', state);
      if (toggle) { toggle.setAttribute('aria-expanded', String(!state)); }
    }

    // Build the list; smooth-scroll and (on mobile) collapse after a tap.
    var byId = {};
    heads.forEach(function (h, i) {
      if (!h.id) { h.id = 'gg-h-' + (i + 1); }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      a.className = 'article-guide__toc-link';
      a.addEventListener('click', function (ev) {
        var target = document.getElementById(h.id);
        if (target) {
          ev.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (history.replaceState) { history.replaceState(null, '', '#' + h.id); }
          if (mq.matches) { collapse(true); }
        }
      });
      li.appendChild(a);
      toc.appendChild(li);
      byId[h.id] = a;
    });

    // Toggle is only interactive on mobile (desktop keeps the list open via CSS).
    if (toggle) {
      toggle.addEventListener('click', function () {
        if (mq.matches) { collapse(!tocWrap.classList.contains('is-collapsed')); }
      });
    }

    // Open on desktop, collapsed on mobile; re-sync on viewport change.
    function syncViewport() { collapse(mq.matches); }
    syncViewport();
    if (mq.addEventListener) { mq.addEventListener('change', syncViewport); }
    else if (mq.addListener) { mq.addListener(syncViewport); }

    // Scroll-spy highlight of the active section.
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            Object.keys(byId).forEach(function (k) { byId[k].classList.remove('is-active'); });
            if (byId[e.target.id]) { byId[e.target.id].classList.add('is-active'); }
          }
        });
      }, { rootMargin: '0px 0px -75% 0px', threshold: 0 });
      heads.forEach(function (h) { obs.observe(h); });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-hub"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-blog-hub]').forEach(function (root) {
    var tabs = root.querySelectorAll('.blog-hub__tab');
    var rows = root.querySelectorAll('.blog-hub__row');
    var search = root.querySelector('.blog-hub__search');
    var empty = root.querySelector('.blog-hub__empty');
    var filter = 'all';
    var query = '';

    // TGGCore: on mobile the category chips scroll horizontally. Show a control
    // row above the chips (progress bar + arrows) only when the strip overflows,
    // so it's obvious there's more to scroll and how much is left.
    var tabsWrap = root.querySelector('.blog-hub__tabs-wrap');
    var strip = root.querySelector('.blog-hub__tabs');
    var thumb = root.querySelector('.blog-hub__tabs-thumb');
    var navPrev = root.querySelector('.blog-hub__tabs-nav--prev');
    var navNext = root.querySelector('.blog-hub__tabs-nav--next');

    function updateNav() {
      if (!strip || !tabsWrap) { return; }
      var max = strip.scrollWidth - strip.clientWidth;
      var x = strip.scrollLeft;
      tabsWrap.classList.toggle('is-scrollable', max > 4);
      // progress thumb behaves like a scrollbar: width = visible/total,
      // offset = scrolled/total, so it fills the track as you reach the end.
      if (thumb) {
        thumb.style.width = (strip.clientWidth / strip.scrollWidth * 100) + '%';
        thumb.style.left = (x / strip.scrollWidth * 100) + '%';
      }
      if (navPrev) { navPrev.disabled = x <= 4; }
      if (navNext) { navNext.disabled = x >= max - 4; }
    }

    if (strip) {
      strip.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      window.addEventListener('load', updateNav);
    }
    if (navPrev) {
      navPrev.addEventListener('click', function () {
        strip.scrollBy({ left: -strip.clientWidth * 0.7, behavior: 'smooth' });
      });
    }
    if (navNext) {
      navNext.addEventListener('click', function () {
        strip.scrollBy({ left: strip.clientWidth * 0.7, behavior: 'smooth' });
      });
    }
    updateNav();

    // TGGCore: client-side pagination over the filtered result set, so the
    // category tabs, counts, and search keep spanning every guide (server-side
    // paging would only see one page's rows).
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 24;
    var page = 1;
    var pager = root.querySelector('[data-page-nav]');
    var prevBtn = root.querySelector('[data-page-prev]');
    var nextBtn = root.querySelector('[data-page-next]');
    var numbers = root.querySelector('[data-page-numbers]');

    // Which page numbers to show: always first + last, a window around the
    // current page, and '…' gaps between (e.g. 1 … 4 5 6 … 12).
    function pageList(cur, total) {
      var out = [];
      for (var i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= cur - 1 && i <= cur + 1)) {
          out.push(i);
        } else if (out[out.length - 1] !== '…') {
          out.push('…');
        }
      }
      return out;
    }

    function renderPager(pages) {
      if (!pager) { return; }
      pager.hidden = pages <= 1;
      if (prevBtn) { prevBtn.disabled = page <= 1; }
      if (nextBtn) { nextBtn.disabled = page >= pages; }
      if (!numbers) { return; }
      numbers.innerHTML = '';
      if (pages <= 1) { return; }
      pageList(page, pages).forEach(function (n) {
        if (n === '…') {
          var gap = document.createElement('span');
          gap.className = 'blog-hub__pager-gap';
          gap.setAttribute('aria-hidden', 'true');
          gap.textContent = '…';
          numbers.appendChild(gap);
          return;
        }
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'blog-hub__pager-num' + (n === page ? ' is-active' : '');
        b.textContent = n;
        b.setAttribute('aria-label', 'Page ' + n);
        if (n === page) { b.setAttribute('aria-current', 'page'); }
        b.addEventListener('click', function () { goTo(n); });
        numbers.appendChild(b);
      });
    }

    function render() {
      // 1. collect rows matching the active filter + query
      var matched = [];
      rows.forEach(function (row) {
        var okCategory = filter === 'all' || row.getAttribute('data-category') === filter;
        var okQuery = !query || (row.getAttribute('data-title') || '').indexOf(query) !== -1;
        if (okCategory && okQuery) { matched.push(row); }
        else { row.style.display = 'none'; }
      });
      // 2. clamp current page to the matched count
      var pages = Math.max(1, Math.ceil(matched.length / perPage));
      if (page > pages) { page = pages; }
      // 3. show only the current page's slice
      var start = (page - 1) * perPage;
      var end = start + perPage;
      matched.forEach(function (row, i) {
        row.style.display = (i >= start && i < end) ? '' : 'none';
      });
      if (empty) { empty.hidden = matched.length !== 0; }
      renderPager(pages);
    }

    function goTo(n) {
      page = n;
      render();
      var top = root.querySelector('.blog-hub__list');
      if (top && top.scrollIntoView) {
        top.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { if (page > 1) { goTo(page - 1); } });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goTo(page + 1); });
    }

    function setActive(val) {
      var matched = false;
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-filter') === val;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) { matched = true; }
      });
      filter = matched ? val : 'all';
      page = 1;
      render();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActive(tab.getAttribute('data-filter'));
      });
    });

    if (search) {
      search.addEventListener('input', function () {
        query = search.value.trim().toLowerCase();
        page = 1;
        render();
      });
    }

    render();

    // TGGCore: deep-link support — ?category=<slug> preselects a tab
    // (used by the Gift Guides hub's "Browse by guide" cards). Unknown or
    // missing values fall back to "all".
    try {
      var cat = (new URLSearchParams(window.location.search).get('category') || '').trim().toLowerCase();
      if (cat) { setActive(cat); }
    } catch (e) {}
  });

  } catch(e) { console.error(e); }
})();
})();
